
const state = {
  sponsors: []
}

const mutations = {
  setSponsors: function (state, payload) {
    state.sponsors = payload
  }
}

const getters = {
  sponsors: state => {
    return state.sponsors
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sponsors.js